// extracted by mini-css-extract-plugin
export var label = "_lj-2";
export var slideContainer = "_lj-0";
export var slider = "_lj-1";